import React, { memo, Fragment, useMemo } from 'react';
import { GCDropdown } from '@modules/common/GCDropdown';
import { Button } from 'reactstrap';
import { TaskService } from '@business/services';
import { TaskPriority } from '@business/constants/task';

export interface PrioritySelectorProps {
  priority: TaskPriority;
  onSelect(priority: TaskPriority): void;
  withButton?: boolean;
  left?: boolean;
  container?: string;
}

export const PrioritySelector = memo((props: PrioritySelectorProps) => {
  const { priority, onSelect, withButton = false } = props;

  const target = useMemo(() => {
    const icon = (
      <i
        className={`fa${priority === TaskPriority.none ? 'r' : ''} fa-flag`}
        style={{ color: TaskService.getPriorityColor(priority, withButton) }}
      ></i>
    );

    if (withButton) {
      return (
        <Button outline color="dark" style={{ marginLeft: 10, borderRadius: '50%', width: 35, height: 35 }}>
          {icon}
        </Button>
      );
    }
    return icon;
  }, [priority, withButton]);

  return (
    <GCDropdown target={target} left={props.left} container={props.container}>
      {setOpen => (
        <Fragment>
          {TaskService.allPriorities().map((p, index) => (
            <a
              key={index}
              className="dropdown-item"
              onClick={() => {
                setOpen(false);
                onSelect(p);
              }}
            >
              <i className="fa fa-flag mr-2" style={{ color: TaskService.getPriorityColor(p) }}></i>
              {TaskService.getPriorityTitle(p)}
            </a>
          ))}
          <div className="dropdown-divider"></div>
          <a className="dropdown-item" onClick={() => onSelect(TaskPriority.none)}>
            <i className="fa fa-times mr-2" style={{ color: '#3e3e3e' }}></i>Clear
          </a>
        </Fragment>
      )}
    </GCDropdown>
  );
});
